import {
  API_VERSION,
  TASK_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_MILESTONE_ORDERTYPES = `${TASK_SERVICE}/milestone-order-templates`;

export const milestoneOrdertypes = {
  /**
   * Creates a new milestone order type.
   *
   * @function create
   * @async
   * @param {Object} params - The parameters for creating a milestone order type.
   * @param {Object} params.data - The data for the new milestone order type.
   * @param {string} [params.data.Id] - The unique identifier of the milestone order type.
   * @param {string} params.data.MilestoneId - The unique identifier of the milestone.
   * @param {string} params.data.OrderTypeId - The unique identifier of the order type.
   * @param {string} params.data.AccountId - The unique identifier of the account.
   * @param {number} params.data.DisplayOrder - The display order of the milestone order type.
   * @param {Object} params.toastMessageConfig - Configuration for toast messages.
   * @returns {Promise<Object>} The response from the API.
   */
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_MILESTONE_ORDERTYPES,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_MILESTONE_ORDERTYPES}/${id}`,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "patch",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_MILESTONE_ORDERTYPES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getAll: async ({
    filters,
    sort,
    params,
    signal,
    toastMessageConfig,
  } = {}) => {
    const options = await apiOptions({
      url: API_MILESTONE_ORDERTYPES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options, toastMessageConfig);
  },
  get: async ({ orderId } = {}) => {
    const options = await apiOptions({
      url: `${API_MILESTONE_ORDERTYPES}/${orderId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
